<div id="mobileHamburgerModal" class="modal left-panel cat-menu-active">
  <div class="menu-container modal">
    <li class="social-icons mobile">
      <a href="https://www.partnerchoice.co.uk/listing/9216/partnerchoice-app"
        ><span class="fa fa-fw fa-lg fa-brands fa-apple"></span
      ></a>
      <a href="https://www.partnerchoice.co.uk/listing/9216/partnerchoice-app"
        ><span class="fa fa-fw fa-lg fa-brands fa-android"></span
      ></a>
      <a (click)="navigate('Users/my-favourites')"
        ><span class="fa fa-fw fa-lg fa-heart"></span
      ></a>
      @if (gazetteUrl) {
      <a [href]="gazetteUrl" target="blank" class="gazette"
        ><img
          class="fa fa-fw fa-lg"
          src="/app/assets/img/homepage/Gazette_Logo.png"
      /></a>
      }
    </li>
    <nav>
      <ul class="menu">
        @for (item of categories; track item) {
        <span>
          @if (item.display_in_menu == 1) {
          <li>
            <a
              (click)="navigate('/category/' + item.slug)"
              title="{{ item.title }}"
              ><span class="fa {{ item.font_icon }}"></span>{{ item.title }}</a
            >
            @if (item.children) {
            <ul>
              @for (child of item.children; track child) {
              <li>
                <a
                  (click)="navigate('/category/' + child.slug)"
                  title="{{ child.title }}"
                  >{{ child.title }}</a
                >
              </li>
              }
            </ul>
            }
          </li>
          }
        </span>
        } @if (!isLoggedIn) {
        <div class="help">
          <nav>
            <ul>
              <li>
                <a href="https://jlpleisurebenefits.zendesk.com/home" title=""
                  >Help?</a
                >
              </li>
            </ul>
          </nav>
        </div>
        }
      </ul>
    </nav>
    @if (isLoggedIn) {
    <div class="extra-categories">
      <p>Explore how we can help you</p>
      <div class="box-container">
        <div class="category-box">
          <a (click)="navigate('/listing/10398/money-matters')">
            <img alt="" src="/app/assets/img/categories/finance.png" />
            <div class="text">Money Matters</div>
          </a>
        </div>
        <div class="category-box">
          <a (click)="navigate('/listing/7956/health-wellbeing-hub')">
            <img alt="" src="/app/assets/img/categories/health.png" />
            <div class="text">Health Hub</div>
          </a>
        </div>
      </div>
    </div>
    }
  </div>
</div>
